<template>
  <v-system-bar
    v-if="isOffline"
    app
    color="red lighten-2"
  >
    <div class="flex-grow-1" />
    <v-icon>signal_wifi_off</v-icon>
    <span>Você está desconectado.</span>
  </v-system-bar>
</template>

<script>
import { VueOfflineMixin } from 'vue-offline'
export default {
  name: 'AppSystemBar',
  mixins: [VueOfflineMixin]
}
</script>
